module.exports = __webpack_public_path__ + "static/laptopCCOS-7b8058de1ff6f9c09c12f1d55d2f123e.jpg";